<template>
  <Form
    :fields="fields"
    :showErrors="showErrors"
    :data="value"
    :serverErrors="serverErrors"
    :disabled="disabled"
    @input="onChange"
    @valid="valid => $emit('valid', valid)"
  />
</template>

<script>
import _ from "lodash";
import Form from "@/components/Form.vue";
import UsStates from "@/assets/us-states.json";
import CaProvinces from "@/assets/canada-provinces.json";

export default {
  name: "ShippingInformation",

  components: { Form },

  props: ["value", "showErrors", "serverErrors", "disabled"],

  computed: {
    stateField() {
      const { country } = this.value;

      let title = "State";
      let type = "select";
      let choices = UsStates;

      if (country === "Canada") {
        title = "Province";
        choices = CaProvinces;
      }

      return {
        placeholder: `Select ${title}`,
        title,
        choices: Object.entries(choices).map(([value, text]) => ({
          text,
          value
        }))
      };
    },

    zipField() {
      const { country } = this.value;

      let mask = "#####";
      let zipRule = "zipCodeUs";

      if (country === "Canada") {
        mask = "A#A #A#";
        zipRule = "zipCodeCa";
      }

      return {
        mask,
        rules: [zipRule]
      };
    },

    fields() {
      return [
        {
          id: "name",
          title: "Name",
          type: "text",
          required: true,
          rules: [["min", 2], "name"]
        },
        { id: "company", title: "Company", type: "text", required: true },
        {
          id: "email",
          title: "Email",
          type: "text",
          required: true,
          rules: ["email"]
        },
        {
          id: "phone",
          title: "Phone",
          type: "text",
          mask: "(###) ###-####",
          required: true,
          rules: ["phoneNumber"]
        },
        {
          id: "address",
          title: "Street / PO Box",
          type: "text",
          required: true
        },
        { id: "city", title: "City", type: "text", required: true },
        {
          id: "country",
          title: "Country",
          type: "select",
          choices: ["United States", "Canada"],
          required: true
        },
        {
          type: "group",
          fields: [
            {
              id: "state",
              type: "select",
              required: true,
              columns: 8,
              ...this.stateField
            },
            {
              id: "zip",
              title: "Zip",
              type: "text",
              required: true,
              columns: 4,
              ...this.zipField
            }
          ]
        },
        {
          id: "requested_arrival_date",
          title: "Requested Arrival Date",
          type: "datepicker",
          min: new Date().toISOString().substr(0, 10),
          hint: "Standard 3-day shipping",
          mask: "##/##/####"
        }
      ];
    }
  },
  methods: {
    onChange(data, field) {
      if (field.id === "country") {
        // reset state field if country is changed
        data = { ...data, zip: "", state: "" };
      }

      this.$emit("input", data);
    }
  }
};
</script>
